// modules
import { handleActions } from 'redux-actions'

// utils
import {
  setPatientActivityLog,
  setActivityLogPredefinedFilter,
  deletePatientActivityLog
} from 'src/store/modules/patient/activityLog'

const initialState = {
  logs: [],
  predefinedActivityLogFilters: {}
}

export default handleActions(
  {
    [setPatientActivityLog](state, { payload: logs }) {
      return {
        ...state,
        logs
      }
    },

    [setActivityLogPredefinedFilter](
      state,
      { payload: predefinedActivityLogFilters }
    ) {
      return {
        ...state,
        predefinedActivityLogFilters
      }
    },

    [deletePatientActivityLog]() {
      return initialState
    }
  },
  initialState
)
